import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { CustomerMasterApiService } from '../CommonController/customer-master-service';
import { DispatchDeviceApiService } from '../CommonController/dispatch-device-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';

@Component({
  selector: 'app-dispatch-device-add-page',
  templateUrl: './dispatch-device-add-page.component.html',
  styleUrls: ['./dispatch-device-add-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonPaginationComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    FormsModule,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatSelect,
    MatOption,
    DatePipe,
    CommonSearchComponent,
  ],
})
export class DispatchDeviceAddPageComponent implements OnInit {
  dispatchDeviceAddForm: FormGroup;

  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  totalItems = 0; // Total number of items
  searchText = ''; // Search text

  batchPageSize = 10;
  batchCurrentPage = 1;
  batchTotalItems = 0;
  dispatchDeviceList = [];
  dispatchDeviceDetailsList = [];

  userPermission = [];
  loggedId = '';
  batchId = '';

  customerList = [];
  uid = '';

  showDeviceDetails = false;
  dispatchDeviceCreate = true;
  dispatchDeviceUpdate = true;

  constructor(
    public dispatchDeviceApiService: DispatchDeviceApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public customerMasterApiService: CustomerMasterApiService
  ) {}

  ngOnInit(): void {
    this.showDeviceDetails = false;
    this.batchId = this.route.snapshot.paramMap.get('id');
    this.checkPermission();
    this.setDispatchDeviceAddForm();
    if (this.batchId !== null) {
      this.dispatchDeviceUpdate = true;
      this.dispatchDeviceCreate = false;
      // this.prePopulation(this.batchId);
      this.getDispatchBatchDeviceList();
    } else {
      this.dispatchDeviceUpdate = false;
      this.dispatchDeviceCreate = true;
    }
    this.fetchCustomerList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    if (this.uid !== null) {
      this.userPermission.forEach((element) => {
        if (element.pageName === 'Dispatch Device') {
          if (element.update === false) {
            this.navigateBack();
          }
        }
      });
    } else {
      this.userPermission.forEach((element) => {
        if (element.pageName === 'Dispatch Device') {
          if (element.create === false) {
            this.navigateBack();
          }
        }
      });
    }
  }

  setDispatchDeviceAddForm() {
    this.dispatchDeviceAddForm = this.fb.group({
      startUin: new FormControl('', [
        SharedValidators.lengthCheckValidator(19, {
          noSpecialChars: true,
          required: true,
        }),
      ]),
      endUin: new FormControl('', [
        SharedValidators.lengthCheckValidator(19, {
          noSpecialChars: true,
          required: true,
        }),
      ]),
      customerName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      dispatchDate: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      userId: new FormControl(
        this.loggedId,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      // totalCount: new FormControl(''),
    });
  }

  prePopulation(batchId) {
    this.spinner.show();
    this.dispatchDeviceApiService
      .getDispatchBatchDeviceList(
        batchId,
        this.currentPage,
        this.pageSize,
        this.searchText
      )
      .subscribe((res) => {
        if (res.status) {
          const data = res.data;
          this.dispatchDeviceAddForm = this.fb.group({
            uid: new FormControl(data.uid, [
              SharedValidators.lengthCheckValidator(19, {
                noSpecialChars: true,
              }),
            ]),

            customerPartNumber: new FormControl(data.customerPartNumber, [
              SharedValidators.requiredAndNoEmptySpaces,
            ]),
            customerName: new FormControl(data.customerName, [
              SharedValidators.requiredAndNoEmptySpaces,
            ]),
          });
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        } else {
          console.error('API Response error:', res.message);
          this.spinner.hide();
        }
      });
  }

  fetchCustomerList() {
    this.spinner.show();
    this.customerMasterApiService.getAllCustomer(1, 100000, '').subscribe({
      next: (res) => {
        this.customerList = res.data;
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        if (error.status === 404) {
          this.customerList = [];
        } else {
          this.commonApiService.openSnackbar(
            'An error occurred while fetching Customers data.'
          );
        }
      },
    });
  }

  validateFormUpdate() {
    if (this.dispatchDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.dispatchDeviceAddForm);
      return;
    } else {
      this.updateData();
    }
  }

  validateFormSave() {
    if (this.dispatchDeviceAddForm.invalid) {
      SharedValidators.markAllAsTouched(this.dispatchDeviceAddForm);
      return;
    } else {
      this.saveData();
    }
  }

  getBatchDeviceList() {
    const startUin = this.dispatchDeviceAddForm.get('startUin')?.value;
    const endUin = this.dispatchDeviceAddForm.get('endUin')?.value;

    this.spinner.show();

    this.dispatchDeviceApiService
      .getDispatchDeviceBatchList(
        startUin,
        endUin,
        this.batchCurrentPage,
        this.batchPageSize,
        this.searchText
      )
      .subscribe({
        next: (res) => {
          this.dispatchDeviceDetailsList = res.data;
          this.batchTotalItems = res.totalItems;
          this.showDeviceDetails = true;
          this.spinner.hide();
        },
        error: (error) => {
          this.dispatchDeviceDetailsList = [];
          this.batchTotalItems = 0;
          this.showDeviceDetails = false;

          this.commonApiService.openSnackbar(
            error.error?.message || 'An error occurred while fetching data.'
          );

          this.spinner.hide();
        },
      });
  }

  showDetails() {
    this.batchCurrentPage = 1;
    this.getBatchDeviceList();
  }

  getDispatchBatchDeviceList() {
    this.spinner.show();
    this.dispatchDeviceApiService
      .getDispatchBatchDeviceList(
        this.batchId,
        this.currentPage,
        this.pageSize,
        this.searchText
      )
      .subscribe({
        next: (res) => {
          this.dispatchDeviceList = res.data;
          this.totalItems = res.totalItems;
          this.spinner.hide();
        },
        error: (error) => {
          this.dispatchDeviceList = [];
          this.totalItems = 0;
          this.commonApiService.openSnackbar(
            error.error?.message ||
              'An error occurred while fetching batch device details.'
          );
          this.spinner.hide();
        },
      });
  }

  saveData() {
    const payload = this.dispatchDeviceAddForm.value;
    payload.createdAt = Date.now();
    this.dispatchDeviceApiService.saveDispatchData(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.router.navigate(['dispatch-device-page']);
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  updateData() {
    this.spinner.show();
    const payload = this.dispatchDeviceAddForm.value;
    payload.id = this.uid;
    payload.updatedAt = Date.now();
    this.dispatchDeviceApiService.updateDispatchDeviceData(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.redirect('dispatch-device-page');
          this.dispatchDeviceUpdate = false;
          this.dispatchDeviceCreate = true;
          this.commonApiService.openSnackbar(res.message);
        } else {
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  exportDispatchBatchToExcel(batchId): void {
    if (confirm('Are You Sure?')) {
      this.spinner.show();
      this.dispatchDeviceApiService
        .exportDispatchBatchDeviceDetails(batchId, this.searchText)
        .subscribe({
          next: (res) => {
            if (res.status) {
              const exportData = res.data.map((device) => ({
                UIN: device.uid,
                IMEI: device.imei,
                ICCID: device.iccid,
                'Customer Name': device.customerName,
                'Model Name': device.modelName,
                'Dispatch Date': device.dispatchDate
                  ? this.formatDateForExport(device.dispatchDate)
                  : '',
              }));
              this.commonApiService.createCSVFile(
                exportData,
                'Uploaded_Dispatched_Batch_Devices'
              );
            } else {
              this.commonApiService.openSnackbar(
                res.message || 'No data found.'
              );
            }
            this.spinner.hide();
          },
          error: (err) => {
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              err?.error?.message ||
                'An error occurred while exporting dispatch batch details.'
            );
          },
        });
    }
  }

  formatDateForExport(date: string | Date): string {
    const dateObj = new Date(date);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  onPageChange(event) {
    this.spinner.show();
    this.currentPage = event;
    this.getDispatchBatchDeviceList(); // Fetch the data for the new pageSize
    // this.searchText = this.dispatchDeviceAddForm.get('dispatchDeviceListSearch').value;
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.getDispatchBatchDeviceList();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.getDispatchBatchDeviceList(); // Fetch the data for the new pageSize
  }

  onBatchPageChange(page: number) {
    this.batchCurrentPage = page;
    this.getBatchDeviceList();
  }

  onBatchSizeChange(size: number) {
    this.batchPageSize = size;
    this.batchCurrentPage = 1;
    this.getBatchDeviceList();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
